// Translations
import form from '../sections/form/translations/tr'

// Translation: Two-factor authentication > Landing (Turkish)
export default Object.freeze({
	sections: { form }
})
